import { AppShell, Burger, Container, Group, Menu, UnstyledButton, useMantineTheme, Button, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { ResourceAvatar, useMedplumProfile } from '@medplum/react';
import { IconChevronDown, IconLogout, IconSettings, IconUserCircle, IconHeart, IconCreditCard } from '@tabler/icons-react';
import { formatHumanName } from '@medplum/core';
import cx from 'clsx';
import { useState, type JSX } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './Header.module.css';

const navigation: Array<{ name: string; href: string }> = [
 // { name: 'Appointments', href: '/appointments' },
 // { name: 'Documents', href: '/documents' },
//  { name: 'Billing & Account', href: '/account/membership-and-billing' },
];

interface HeaderProps {
  onBurgerClick?: () => void;
}

export function Header({ onBurgerClick }: HeaderProps): JSX.Element {
  const navigate = useNavigate();
  const profile = useMedplumProfile();
  const theme = useMantineTheme();
  const [opened, { toggle }] = useDisclosure(false);
  const [userMenuOpened, setUserMenuOpened] = useState(false);

  const clientName = profile?.name?.[0] ? formatHumanName(profile.name[0]) : 'Client Portal';

  return (
    <AppShell.Header>
      <Container>
        <div className={classes.inner}>
          <Group gap="sm">
            <UnstyledButton className={classes.logoButton} onClick={() => navigate('/')}>
              <Group gap="sm">
                <IconHeart size={36} color="#F4B6A1" stroke={1.5} />
                <Text 
                  size="24px"
                  fw={700} 
                  style={{ 
                    fontFamily: 'Merriweather, serif',
                    color: '#333333',
                    letterSpacing: '-0.5px',
                  }}
                >
                  FeelHeard
                  <span style={{ fontSize: '0.9em', color: '#C2A4D6' }}>.me</span>
                </Text>
              </Group>
            </UnstyledButton>
          </Group>

          <Group gap={5} className={classes.links}>
            {navigation.map((link) => (
              <Link key={link.name} to={link.href} className={classes.link}>
                {link.name}
              </Link>
            ))}
           {/* <Link to="/get-care" className={classes.link}>
              Schedule Session
            </Link>*/}
          </Group>

          <Group>
            <Menu
              width={260}
              shadow="xl"
              position="bottom-end"
              transitionProps={{ transition: 'pop-top-right' }}
              onClose={() => setUserMenuOpened(false)}
              onOpen={() => setUserMenuOpened(true)}
            >
              <Menu.Target>
                <UnstyledButton className={cx(classes.user, { [classes.userActive]: userMenuOpened })}>
                  <Group gap={7}>
                    <ResourceAvatar radius="xl" value={profile} />
                    <IconChevronDown size={12} stroke={1.5} />
                  </Group>
                </UnstyledButton>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  leftSection={<IconUserCircle size={16} color={theme.colors.red[6]} stroke={1.5} />}
                  onClick={() => navigate('/documents/forms/profile')}
                >
                  Your profile
                </Menu.Item>
             {/*   <Menu.Item
                  leftSection={<IconSettings size={16} color={theme.colors.blue[6]} stroke={1.5} />}
                  onClick={() => navigate('/documents/forms/profile')}
                >
                  Settings
                </Menu.Item>*/}
                <Menu.Item
                  leftSection={<IconCreditCard size={16} color={theme.colors.violet[6]} stroke={1.5} />}
                  onClick={() => navigate('/settings/subscription')}
                > 
                  Subscription
                </Menu.Item>
                <Menu.Item
                  leftSection={<IconLogout size={16} color={theme.colors.gray[6]} stroke={1.5} />}
                  onClick={() => navigate('/signout')}
                >
                  Sign out
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
            <Burger 
              opened={opened} 
              onClick={() => {
                toggle();
                if (onBurgerClick) {
                  onBurgerClick();
                }
              }} 
              className={classes.burger} 
              size="sm" 
            />
          </Group>
        </div>
      </Container>
    </AppShell.Header>
  );
}